import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { FixedWidth } from '../../CommonComponents/commonStyles';
import Exporter from './Components/Exporter/Exporter';
import BreadcrumbComponent from '../../CommonComponents/Breadcrumb/Breadcrumb';
import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser,
  encryptAccountNumber,
  decryptAccountNumber,
} from '../../utils/sessionUtil';
import ToJS from '../Contributions/Pages/ContributionsDashboard/HOC/toJS';
import {
  fetchFinancialAdvisorsData,
  enableBack,
  resetEnableBack,
  lazyLoadFetch,
  resetData,
} from './action';
import { primaryAccountChanged } from '../../actions/globalActions';
import { FaDetailedCard, FaCard } from '../../CommonComponents/Cards/FinancialAdvisorCard/FaCard';
import {
  AccountDetailContainer,
  CardRow,
  FinancialAdvisorDashboardBody,
  LazyloadWrapper,
  ColWrapper,
  NoAdvisorData,
  AdvisorFixedWidth,
} from './styles';
import { financialApi, lazyApi } from './config/config';
import AccountSummary from '../../CommonComponents/AccountInformation/FinancialAdvisor/AccountSummary/AccountSummary';
import SummaryNotes from './Components/SummaryNotes/SummaryNotes';
import SearchSection from './Components/SearchSection/SearchSection';
import { LazyLoadButton } from './Components/Buttons/Buttons';
import { ContributionGreyBackgroundSection } from '../Contributions/Pages/ContributionsDashboard/styles';
import FilterCapsules from './Components/Filters/FilterCapsules/FilterCapsules';
import Popup from './Components/Popup/Popup';
import Preloader from '../../CommonComponents/Preloader/Preloader';
import { initiateTracking } from '../../utils/commonUtil';
import PropTypes from 'prop-types';
import { financialAdvisorStates } from './selectors';

function getSorted(searchArray, field, type) {
  return _.orderBy(
    searchArray,
    [
      function(o) {
        return field !== 'currentBalance' ? o[field].toLowerCase() : o[field];
      },
    ],
    [type]
  );
}

function deriveSort(searchArray, sortType) {
  let result = null;
  if (sortType === 'lastNameAsc') {
    result = getSorted(searchArray, 'clientLasttName', 'asc');
  } else if (sortType === 'firstNameAsc') {
    result = getSorted(searchArray, 'clientFirstName', 'asc');
  } else if (sortType === 'BalanceAsc') {
    result = getSorted(searchArray, 'currentBalance', 'asc');
  } else if (sortType === 'BalanceDesc') {
    result = getSorted(searchArray, 'currentBalance', 'desc');
  }
  return result;
}

function getFiltetedMinMax(filterArray, condition, min, max) {
  let result = filterArray.filter((checker) => {
    if (min <= checker.currentBalance && checker.currentBalance <= max) {
      return true;
    }
  });
  return result;
}

function getFiltetedMinMaxYear(filterArray, condition, min, max) {
  let result = filterArray.filter((checker) => {
    let dateOpened = parseInt(moment(checker.dateOpened).format('YYYY'));
    if (parseInt(min) <= dateOpened && dateOpened <= parseInt(max)) {
      return true;
    }
  });
  return result;
}

function getFiltetedType(filterArray, condition) {
  let choices = condition.selectedVal;
  let result = filterArray.filter((checker) => {
    if (choices.indexOf(checker.state) !== -1) {
      return true;
    }
  });
  return result;
}

function getFiltetedRoles(filterArray, condition) {
  let choice = condition.selectedVal;
  let result = filterArray.filter((checker) => {
    if (checker.role === choice) {
      return true;
    }
  });
  return result;
}

function deriveFilter(filterArray, condition) {
  let result = null;
  if (condition.type === 'Balance') {
    result = getFiltetedMinMax(
      filterArray,
      condition,
      condition.selectedMin,
      condition.selectedMax
    );
  } else if (condition.type === 'Year Opened') {
    result = getFiltetedMinMaxYear(
      filterArray,
      condition,
      condition.selectedMin,
      condition.selectedMax
    );
  } else if (condition.type === 'States') {
    result = getFiltetedType(filterArray, condition);
  } else if (condition.type === 'Designated Role') {
    result = getFiltetedRoles(filterArray, condition);
  }
  return result;
}

var investmentPoolsTableData = '';
var investmentPoolsTableData_protfoliobuilder;
export class FinancialAdvisorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputQueryString: null,
      chartNames: [],
      data: '',
      toggle: false,
      filter: false,
      sort: true,
      sortType: 'lastNameAsc',
      popup: false,
      mobileViewFlag: false,
      searchAndFilterArray: null,
      advisorsData: [],
      popupData: {},
      lazyArray: [],
      backupArray: null,
      assetsDetails: {
        accounts: 0,
        assets: 0,
      },
      totalAccountCountFlag: true,
      totalAccountCountOfFinancialAdviser: 0,
      clickedFilter: null,
      filters: [
        {
          type: 'Balance',
          minRange: null,
          maxRange: null,
          selectedMax: null,
          selectedMin: null,
          selectedVal: null,
          visible: true,
          popup: false,
          web: '10%',
          applicable: false,
          minInputValue: null,
          maxInputValue: null,
        },
        {
          type: 'Year Opened',
          minRange: null,
          maxRange: null,
          selectedMax: null,
          selectedMin: null,
          selectedVal: null,
          visible: true,
          popup: false,
          web: '30%',
          applicable: false,
          minInputValue: null,
          maxInputValue: null,
        },
        {
          type: 'States',
          choices: [],
          selectedChoices: [],
          selectedVal: [],
          visible: true,
          popup: false,
          web: '18%',
          applicable: false,
        },
        {
          type: 'Designated Role',
          choices: [],
          selectedChoices: [],
          selectedVal: 'select',
          visible: true,
          popup: false,
          web: '47%',
          applicable: false,
        },
      ],
    };
    this.countVal = 1;
    this.title = 'Financial Advisor Dashboard';
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let dafAccountId = getPrimaryAccount().userId;
    let partyId = getAccountData().partyId;
    if (window.top.frames.topBar && isGeminiUser()) {
      let topBarObj = window.top.frames.topBar;
      topBarObj.postMessage(
        {
          message: "casegeneration",
          dafAccountId: dafAccountId,
          partyId: partyId
        },
        process.env.REACT_APP_GEMINI_CSR_URL
      );
    }
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    if (!userData.financialAdvisorForAnyAccount) {
      sessionStorage.removeItem('financialAdvisorPrimaryAccount');
      this.props.resetEnableBack();
      this.goToPage('/');
    }
    const primaryAcc = JSON.parse(
      sessionStorage.getItem('financialAdvisorPrimaryAccount')
    );
    if (primaryAcc) {
      const financialPrimaryAcc = JSON.parse(
        sessionStorage.getItem('financialAdvisorPrimaryAccount')
      );
      sessionStorage.setItem(
        'primaryAccount',
        JSON.stringify(financialPrimaryAcc)
      );
      sessionStorage.removeItem('financialAdvisorPrimaryAccount');
      this.props.accountChanged(primaryAcc.userId);
    }
    sessionStorage.removeItem('enableBack');
    sessionStorage.setItem('isFinancialAdvisor', true);
    this.props.resetEnableBack();
    this.props.fetchFinancialAdvisorsData(financialApi());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accountID !== nextProps.accountID) {
      this.props.resetData();
      this.props.fetchFinancialAdvisorsData(financialApi());
    }
    if (nextProps.financialData) {
      this.setState({ advisorsData: nextProps.financialData }, () => {
        if (this.state.advisorsData) {
          // sort in asc*************with advisor Data
          if (this.state.advisorsData && this.state.advisorsData.length) {
            let sortArray = _.orderBy(
              this.state.advisorsData,
              [
                function(o) {
                  return o['clientLasttName'];
                },
              ],
              ['asc']
            );
            let tempArray = sortArray;
            let assetsObj = this.calcualteAccountSum(tempArray);
            this.setState({ lazyArray: tempArray, assetsDetails: assetsObj });
          }
        }
      });
    }
    if (!nextProps.isLoading) {
      this.setFilterData(nextProps);
    }
  }

  componentWillUnmount() {
    this.props.resetData();
    sessionStorage.removeItem('isFinancialAdvisor');
  }

  analyticsHandler = (eventType, action, name) => {
    initiateTracking(
      eventType,
      this.title,
      action ? action : '',
      name ? name : ''
    );
  };

  calcualteAccountSum(sortedArray) {
    let count = 0;
    let sum = 0;
    for (let itr = 0; itr < sortedArray.length; itr++) {
      count = count + 1;
      sum = sum + sortedArray[itr].currentBalance;
    }
    let assetsObj = { ...this.state.assetsDetails };
    assetsObj.accounts = count;
    assetsObj.assets = sum;
    return assetsObj;
  }

  setFilterData = (data) => {
    const updatedFilters = [...this.state.filters];
    let minBalance = data['filtersAvailable'] && data['filtersAvailable'].balance && data['filtersAvailable'].balance.min;
    let maxBalance = data['filtersAvailable'] && data['filtersAvailable'].balance && data['filtersAvailable'].balance.max;
    let minYear = data['filtersAvailable'] && data['filtersAvailable'].yearOpened && data['filtersAvailable'].yearOpened.min;
    let maxYear = data['filtersAvailable'] && data['filtersAvailable'].yearOpened && data['filtersAvailable'].yearOpened.max;
    if (
      data.financialData.length === 1 &&
      minBalance === maxBalance &&
      minYear === maxYear
    ) {
      minYear = -1;
      minBalance = -1;
    }
    updatedFilters[0].minInputValue = minBalance;
    updatedFilters[0].maxInputValue = maxBalance;
    updatedFilters[0].minRange = minBalance;
    updatedFilters[0].maxRange = maxBalance;
    updatedFilters[1].minInputValue = minYear;
    updatedFilters[1].maxInputValue = maxYear;
    updatedFilters[1].minRange = minYear;
    updatedFilters[1].maxRange = maxYear;
    updatedFilters[2].choices = data['states'];
    updatedFilters[3].choices = data['roles'];
    this.setState({ filters: updatedFilters });
  };

  popupRender = (accountId) => {
    this.analyticsHandler('viewFullDetails', '', 'View Full Details');
    this.setState({ popupData: accountId }, () => {
      investmentPoolsTableData_protfoliobuilder = undefined;
      var totalSum = 0;
      var pools = _.cloneDeep(accountId.investmentAllocation.investmentPools);
      investmentPoolsTableData = _.groupBy(pools, function(pools) {
        return pools.type;
      });
      if (
        investmentPoolsTableData['BUILDING BLOCKS'] ||
        investmentPoolsTableData['SPECIFIC REGIONS'] ||
        investmentPoolsTableData['BALANCED FUNDS']
      ) {
        investmentPoolsTableData_protfoliobuilder = [];
      }

      if (investmentPoolsTableData['BUILDING BLOCKS']) {
        investmentPoolsTableData_protfoliobuilder.push(
          ...investmentPoolsTableData['BUILDING BLOCKS']
        );
      }
      if (investmentPoolsTableData['SPECIFIC REGIONS']) {
        investmentPoolsTableData_protfoliobuilder.push(
          ...investmentPoolsTableData['SPECIFIC REGIONS']
        );
      }
      if (investmentPoolsTableData['BALANCED FUNDS']) {
        investmentPoolsTableData_protfoliobuilder.push(
          ...investmentPoolsTableData['BALANCED FUNDS']
        );
      }

      let pieChartData = [];
      let pieChartNames = [];
      if (accountId.investmentAllocation.investmentPools.length == 0) {
        this.setState({
          errorMessage: '',
        });
      } else {
        accountId.investmentAllocation.investmentPools.forEach((item) => {
          if (typeof item.currentBalance === 'number') {
            let chunks = [];
            chunks[0] = item.currentBalance;
            chunks[1] = (item.currentBalance / accountId.currentBalance) * 100;
            chunks[2] = item.poolName;
            let Names = [];
            Names[0] = item.poolName;
            totalSum = chunks[1] + totalSum;
            pieChartData.push(chunks);
            pieChartNames.push(Names);
          } else {
            this.setState({
              errorMessage: 'Unable to render the allocation chart',
            });
          }
        });
        if (Math.round(totalSum) != 100) {
          this.setState({
            errorMessage: 'Unable to render the allocation chart',
          });
        } else {
          this.setState({
            data: pieChartData,
            chartNames: pieChartNames,
            popup: true,
          });
        }
      }
    });
  };

  goToPage = (path) => {
    this.props.history.push(path);
  };

  handleButtonClick = (accID) => {
    let account = accID.accountNumber;
    let sessionAccounts = JSON.parse(sessionStorage.getItem('userData'));
    let allAccounts = sessionAccounts.Accounts;
    var encryptedAccNum = encryptAccountNumber(account);
    let pos = null;
    for (let itr = 0; itr < allAccounts.length; itr++) {
      let keys = Object.keys(allAccounts[itr]);
      if (keys.indexOf(encryptedAccNum) !== -1) {
        pos = itr;
        break;
      }
    }
    let primaryAccObj = allAccounts[pos];
    primaryAccObj['accountNumber'] = decryptAccountNumber(encryptedAccNum);
    primaryAccObj['userId'] = allAccounts[pos][encryptedAccNum];
    const primaryAcc = JSON.parse(sessionStorage.getItem('primaryAccount'));
    sessionStorage.setItem(
      'financialAdvisorPrimaryAccount',
      JSON.stringify(primaryAcc)
    );
    sessionStorage.setItem('primaryAccount', JSON.stringify(primaryAccObj));
    this.props.accountChanged(allAccounts[pos][encryptedAccNum]);
    this.props.setRedirectEnableBack();
    sessionStorage.setItem('enableBack', true);
    this.props.history.push({
      pathname: '/',
      state: { enableBack: true },
    });
  };

  clearAllFilter = () => {
    let filters = this.state.filters.slice();
    for (let itr = 0; itr < filters.length; itr++) {
      filters[itr].visible = false;
      filters[itr].applicable = false;
      if (
        filters[itr].type === 'Balance' ||
        filters[itr].type === 'Year Opened'
      ) {
        filters[itr].selectedMax = null;
        filters[itr].selectedMin = null;
      } else if (filters[itr].type === 'States') {
        filters[itr].selectedVal = [];
      } else {
        filters[itr].selectedVal = 'select';
      }
    }
    this.setState({ filter: false, filters: filters }, () => {
      this.handleSortAndFilter(
        null,
        null,
        this.state.sort,
        this.state.filter,
        this.state.sortType
      );
    });
  };

  lazyLoader() {
    // no need for sort
    this.props.getLazyLoadDataType(lazyApi(this.props.lazyCount));
    // this.props.accountsDivider.current.nextElementSibling.scrollIntoView(false);
  }

  closeFilter = (capsule) => {
    let allFilter = false;
    let filter = this.state.filters.slice();
    let updatedFilters = filter.map((type) => {
      if (type.type === capsule.type) {
        type.visible = false;
        type.applicable = false;
        type.popup = false;
        if (type.selectedMax) {
          type.selectedMax = null;
          type.selectedMin = null;
        }
        if (type.type === 'States') {
          type.selectedVal = [];
        }
        if (type.type === 'Designated Role') {
          type.selectedVal = 'select';
        }
      }
      return type;
    });
    for (let itr = 0; itr < updatedFilters.length; itr++) {
      allFilter = allFilter || updatedFilters[itr].visible;
    }
    this.setState(
      { filters: updatedFilters, filter: allFilter, mobileViewFlag: false },
      () => {
        this.checkFilterStatus();
      }
    );
  };

  toggleHandler = () => {
    this.setState((prevState) => ({ toggle: !prevState.toggle }));
  };

  handleSortAndFilter = (
    searchResult,
    searchArray,
    isSort,
    isFilter,
    sortType
  ) => {
    if (isFilter) {
      if (this.state.searchAndFilterArray === null) {
        const filterArray = Object.assign(this.state.advisorsData);
        const conditions = Object.assign(this.state.filters);
        let result = filterArray;
        for (let con = 0; con < conditions.length; con++) {
          if (conditions[con].applicable) {
            result = [...deriveFilter(result, conditions[con])];
          }
        }
        let results = deriveSort(result, sortType);
        let assetsObj = this.calcualteAccountSum(results);
        this.setState({
          assetsDetails: assetsObj,
          lazyArray: results,
          totalAccountCountFlag: false,
        });
      } else if (this.state.searchAndFilterArray !== null) {
        const filterArray = Object.assign(this.state.searchAndFilterArray);
        const conditions = Object.assign(this.state.filters);
        let result = filterArray;
        for (let con = 0; con < conditions.length; con++) {
          if (conditions[con].applicable) {
            result = [...deriveFilter(result, conditions[con])];
          }
        }
        let results = deriveSort(result, sortType);
        let assetsObj = this.calcualteAccountSum(results);
        this.setState({
          assetsDetails: assetsObj,
          searchAndFilterArray: results,
        });
      }
    } else if (isSort) {
      if (searchResult !== null && searchResult !== '') {
        let resultantArray = searchArray.filter((item, key) => {
          let fullNameChecker =
            item.clientFirstName + ' ' + item.clientLasttName;
          if (
            item.clientFirstName
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            item.accountName
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            item.accountNumber
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            item.clientLasttName
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            fullNameChecker.toLowerCase().includes(searchResult.toLowerCase())
          ) {
            return true;
          }
          return false;
        });
        let sortedArray = null;
        if (resultantArray.length !== 0) {
          sortedArray = getSorted(resultantArray, 'clientLasttName', 'asc');
        } else {
          sortedArray = resultantArray;
        }
        let assetsObj = this.calcualteAccountSum(sortedArray);
        this.setState({
          backupArray: sortedArray,
          searchAndFilterArray: sortedArray,
          assetsDetails: assetsObj,
        });
      } else {
        if (this.state.searchAndFilterArray === null) {
          const searchArray = Object.assign(this.state.advisorsData);
          const result = deriveSort(searchArray, sortType);
          let assetsObj = this.calcualteAccountSum(result);
          this.setState({
            assetsDetails: assetsObj,
            lazyArray: result,
            totalAccountCountFlag: false,
          });
        } else if (this.state.searchAndFilterArray !== null) {
          const searchArray = Object.assign(this.state.searchAndFilterArray);
          const result = deriveSort(searchArray, sortType);
          let assetsObj = this.calcualteAccountSum(result);
          this.setState({
            assetsDetails: assetsObj,
            searchAndFilterArray: result,
          });
        }
      }
    }
  };

  searchHandler = () => {
    const result = this.state.inputQueryString;
    const searchArray = Object.assign(this.state.advisorsData);
    this.setState(
      { sort: true },
      this.handleSortAndFilter(
        result,
        searchArray,
        this.state.sort,
        this.state.filter,
        this.state.sortType
      )
    );
  };

  resetInputHandler = (e) => {
    if (e.target.value === '') {
      // changing into advisors data
      let tempArray = [...this.state.advisorsData];
      const result = deriveSort(tempArray, this.state.sortType);
      // new condition will be added
      let assetsObj = this.calcualteAccountSum(result);
      this.setState({
        lazyArray: result,
        searchAndFilterArray: null,
        backupArray: null,
        assetsDetails: assetsObj,
        inputQueryString: e.target.value,
      });
    } else {
      this.setState({
        inputQueryString: e.target.value,
      });
    }
  };

  sortHandler = (value) => {
    this.setState({ sort: true, sortType: value }, () =>
      this.handleSortAndFilter(
        null,
        null,
        this.state.sort,
        this.state.filter,
        this.state.sortType
      )
    );
  };

  filterHandler = (type) => {
    let updatedFilters = [...this.state.filters];
    if (
      this.state.clickedFilter !== null &&
      type !== this.state.clickedFilter
    ) {
      updatedFilters[this.state.clickedFilter].popup = false;
    }
    if (this.state.clickedFilter !== null) {
      updatedFilters[this.state.clickedFilter].popup = false;
      this.setState({ filters: updatedFilters, clickedFilter: null }, () => {
        updatedFilters[type].popup = !updatedFilters[type].popup;
        this.setState({ filters: updatedFilters, clickedFilter: type });
      });
    } else {
      updatedFilters[type].popup = !updatedFilters[type].popup;
      this.setState({ filters: updatedFilters, clickedFilter: type });
    }
  };

  lazyButton = () => {
    if (this.props.accountsAvailable) {
      return (
        <LazyloadWrapper>
          <LazyLoadButton
            lazyCnt={this.props.accountsAvailable}
            lazyLoadHandle={this.lazyLoader.bind(this)}
          />
        </LazyloadWrapper>
      );
    } else {
      return null;
    }
  };

  closeModalHandler = () => {
    let updatedFilters = [...this.state.filters];
    for (let itr = 0; itr < updatedFilters.length; itr++) {
      updatedFilters[itr].popup = false;
    }
    this.setState({ filters: updatedFilters, clickedFilter: null });
  };

  checkFilterStatus = () => {
    let updatedFilters = [...this.state.filters];
    let checkFlag = false;
    for (let itr = 0; itr < updatedFilters.length; itr++) {
      if (updatedFilters[itr].applicable === true) {
        checkFlag = true;
        break;
      }
    }
    if (checkFlag === false) {
      let tempArray = [...this.state.advisorsData];
      let assetsObj = this.calcualteAccountSum(tempArray);
      this.setState(
        {
          assetsDetails: assetsObj,
          filter: checkFlag,
          lazyArray: this.state.advisorsData,
        },
        (closeFilterFlag) => {
          if (closeFilterFlag) {
          }
          this.handleSortAndFilter(
            null,
            null,
            this.state.sort,
            this.state.filter,
            this.state.sortType
          );
        }
      );
    } else {
      this.handleSortAndFilter(
        null,
        null,
        this.state.sort,
        this.state.filter,
        this.state.sortType
      );
    }
  };

  handleFilterHandler = (value, type, minMaxType) => {
    if (type === 'roles') {
      let updatedFilters = [...this.state.filters];
      updatedFilters[3].selectedVal = value;
      if (value === 'select') {
        updatedFilters[3].applicable = false;
        this.setState({ filters: updatedFilters }, () =>
          this.checkFilterStatus()
        );
      } else {
        updatedFilters[3].applicable = true;
        updatedFilters[3].visible = true;
        this.setState({ filter: true, filters: updatedFilters }, () =>
          this.handleSortAndFilter(
            null,
            null,
            this.state.sort,
            this.state.filter,
            this.state.sortType
          )
        );
      }
    } else if (type === 'states') {
      let updatedFilters = [...this.state.filters];
      updatedFilters[2].selectedVal = value;
      if (value.length === 0) {
        updatedFilters[2].applicable = false;
        updatedFilters[2].visible = true;
        this.setState({ filters: updatedFilters }, () => {
          this.checkFilterStatus();
        });
      } else {
        updatedFilters[2].visible = true;
        updatedFilters[2].applicable = true;
        this.setState({ filter: true, filters: updatedFilters }, () =>
          this.handleSortAndFilter(
            null,
            null,
            this.state.sort,
            this.state.filter,
            this.state.sortType
          )
        );
      }
    } else if (type === 'balance') {
      let tempValue = [];
      let updatedFilters = [...this.state.filters];
      if (minMaxType === 'min') {
        tempValue[0] = value;
        tempValue[1] = updatedFilters[0].selectedMax
          ? updatedFilters[0].selectedMax
          : updatedFilters[0].maxInputValue;
        value = tempValue;
      } else if (minMaxType === 'max') {
        tempValue[0] = updatedFilters[0].selectedMin
          ? updatedFilters[0].selectedMin
          : updatedFilters[0].minInputValue;
        tempValue[1] = value;
        value = tempValue;
      }
      let [min, max] = value;
      if (
        parseInt(min) === parseInt(updatedFilters[0].minRange) &&
        parseInt(max) === parseInt(updatedFilters[0].maxRange)
      ) {
        updatedFilters[0].applicable = false;
        this.setState({ filter: updatedFilters }, () =>
          this.checkFilterStatus()
        );
      } else {
        updatedFilters[0].minInputValue = min;
        updatedFilters[0].maxInputValue = max;
        updatedFilters[0].selectedMin = min;
        updatedFilters[0].selectedMax = max;
        updatedFilters[0].applicable = true;
        updatedFilters[0].visible = true;
        this.setState({ filter: true, filters: updatedFilters }, () =>
          this.handleSortAndFilter(
            null,
            null,
            this.state.sort,
            this.state.filter,
            this.state.sortType
          )
        );
      }
    } else if (type === 'year') {
      let tempValue = [];
      let updatedFilters = [...this.state.filters];
      if (minMaxType === 'min') {
        tempValue[0] = value;
        tempValue[1] = updatedFilters[1].selectedMax
          ? updatedFilters[1].selectedMax
          : updatedFilters[1].maxInputValue;
        value = tempValue;
      } else if (minMaxType === 'max') {
        tempValue[0] = updatedFilters[1].selectedMin
          ? updatedFilters[1].selectedMin
          : updatedFilters[1].minInputValue;
        tempValue[1] = value;
        value = tempValue;
      }
      let [min, max] = value;
      if (
        parseInt(min) ===
          parseInt(moment(updatedFilters[1].minRange).format('YYYY')) &&
        parseInt(max) ===
          parseInt(moment(updatedFilters[1].maxRange).format('YYYY'))
      ) {
        updatedFilters[1].applicable = false;
        this.setState({ filter: updatedFilters }, () =>
          this.checkFilterStatus()
        );
      }
      updatedFilters[1].minInputValue = min;
      updatedFilters[1].maxInputValue = max;
      updatedFilters[1].selectedMin = min;
      updatedFilters[1].selectedMax = max;
      updatedFilters[1].applicable = true;
      updatedFilters[1].visible = true;
      this.setState({ filter: true, filters: updatedFilters }, () =>
        this.handleSortAndFilter(
          null,
          null,
          this.state.sort,
          this.state.filter,
          this.state.sortType
        )
      );
    }
  };

  mobileViewHandler = () => {
    this.setState((prevState) => ({
      mobileViewFlag: !prevState.mobileViewFlag,
    }));
  };

  inputHandler = (value, type) => {
    this.handleFilterHandler(value, type);
  };

  render() {
    const { isLoading, accountsAvailable, lazyLoading } = this.props;

    if (isLoading) return <Preloader data-test='loading-data'/>;

    const {
      toggle,
      filters,
      popup,
      lazyArray,
      searchAndFilterArray,
    } = this.state;
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: 'Home',
          path: '/',
        },
        {
          routeName: 'Account Overview',
          path: 'Financial Advisor',
        },
      ];
    };
    let faDetailCardData = [...this.state.lazyArray];
    if (this.state.searchAndFilterArray) {
      faDetailCardData = [...this.state.searchAndFilterArray];
    }
    return (
      <FinancialAdvisorDashboardBody>
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
        </FixedWidth>
        <FixedWidth>
          <AccountSummary userData={this.props.userData} />
          <SearchSection
            selected={this.handleFilterHandler}
            closed={this.closeModalHandler}
            clicked={this.filterHandler}
            value={this.state.sortType}
            assets={this.state.assetsDetails}
            selectedVal={this.state.sortType}
            sorted={(value) => this.sortHandler(value)}
            restored={(e) => this.resetInputHandler(e)}
            searched={this.searchHandler}
            filterType={this.state.toggle ? 'Grid' : 'List'}
            filters={filters}
            changeState={() => this.toggleHandler()}
            mobileViewHandler={this.mobileViewHandler}
            mobileViewFlag={this.state.mobileViewFlag}
            reset={this.resetFiltersHandler}
            closeFilter={(filter) => this.closeFilter(filter)}
          />
          {window.innerWidth > 767 && this.state.filter ? (
            <Row>
              <Col span={16}>
                <FilterCapsules
                  closeFilter={(capsule) => this.closeFilter(capsule)}
                  filters={filters}
                  cleared={this.clearAllFilter}
                  reset={this.resetFiltersHandler}
                />
              </Col>
              <ColWrapper span={8}>
                <Exporter
                  handleExportAnalytics={(eventType, action, tabName) =>
                    this.analyticsHandler(eventType, action, tabName)
                  }
                  data={this.state.advisorsData}
                  IntialArray={lazyArray}
                  sFArray={searchAndFilterArray}
                />
              </ColWrapper>
            </Row>
          ) : (
            <Row>
              <Col xs={{ span: 24 }} lg={{ span: 0 }}>
                <FilterCapsules
                  closeFilter={(capsule) => this.closeFilter(capsule)}
                  filters={filters}
                  cleared={this.clearAllFilter}
                  reset={this.resetFiltersHandler}
                />
              </Col>
              <ColWrapper span={24}>
                <Exporter
                  data={this.state.advisorsData}
                  handleExportAnalytics={(eventType, action, tabName) =>
                    this.analyticsHandler(eventType, action, tabName)
                  }
                  IntialArray={lazyArray}
                  sFArray={searchAndFilterArray}
                />
              </ColWrapper>
            </Row>
          )}
        </FixedWidth>
        <ContributionGreyBackgroundSection>
          <AdvisorFixedWidth>
            <AccountDetailContainer>
              {faDetailCardData.length !== 0 ? (
                <CardRow>
                  <Col span={24}>
                    {toggle ? (
                      <FaCard
                        faCardData={lazyArray}
                        filteredArray={searchAndFilterArray}
                        popupRender={this.popupRender}
                        handleButtonClick={this.handleButtonClick}
                      />
                    ) : (
                      <FaDetailedCard
                        faDetailCardData={lazyArray}
                        filteredArray={searchAndFilterArray}
                        popupRender={this.popupRender}
                        handleButtonClick={this.handleButtonClick}
                      />
                    )}
                  </Col>
                </CardRow>
              ) : (
                <NoAdvisorData>No results found for search query</NoAdvisorData>
              )}
            </AccountDetailContainer>
            {lazyLoading ? (
              <Preloader />
            ) : accountsAvailable ? (
              this.lazyButton()
            ) : null}
          </AdvisorFixedWidth>
        </ContributionGreyBackgroundSection>
        <FixedWidth>
          <SummaryNotes
            goToPage={(path) => this.goToPage(path)}
            carouselData={this.props.carouselData}
          />
        </FixedWidth>
        {popup ? (
          <Popup
            popupData={this.state.popupData}
            data={this.state.data}
            chartNames={this.state.chartNames}
            errorMessage={this.state.errorMessage}
            cancelModal={() => this.setState({ popup: false })}
          />
        ) : (
          ''
        )}
      </FinancialAdvisorDashboardBody>
    );
  }
}

const mapStateToProps = (state) => ({
  ...financialAdvisorStates(state.toJS()),
  // need to change with selectors once the bug is fixed
  lazyCount: state.getIn(['financialAdvisorDashboard', 'lazyData', 'count']),
  accountsAvailable: state.getIn([
    'financialAdvisorDashboard',
    'lazyData',
    'accountsAvailable',
  ]),
  lazyLoading: state.getIn([
    'financialAdvisorDashboard',
    'lazyData',
    'isLoading',
  ]),
});

const mapDispatchToProps = (dispatch) => ({
  fetchFinancialAdvisorsData: (data) =>
    dispatch(fetchFinancialAdvisorsData(data)),
  accountChanged: (data) => dispatch(primaryAccountChanged(data)),
  setRedirectEnableBack: () => dispatch(enableBack()),
  resetEnableBack: () => dispatch(resetEnableBack()),
  getLazyLoadDataType: (data) => dispatch(lazyLoadFetch(data)),
  resetData: () => dispatch(resetData()),
});

export default ToJS(
  connect(mapStateToProps, mapDispatchToProps)(FinancialAdvisorDashboard)
);

FinancialAdvisorDashboard.propTypes = {
  accountChanged: PropTypes.func,
  accountID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fetchFinancialAdvisorsData: PropTypes.func,
  filtersAvailable: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  financialAdviser: PropTypes.bool,
  financialData: PropTypes.shape({
    accountName: PropTypes.string,
    accountNumber: PropTypes.string,
    clientFirstName: PropTypes.string,
    clientLasttName: PropTypes.string,
    clientMiddleName: PropTypes.string,
    clientPrefix: PropTypes.string,
    clientSuffix: PropTypes.string,
    currentBalance: PropTypes.number,
    dateOpened: PropTypes.number,
    investmentAllocation: PropTypes.object,
    lastContributionDate: PropTypes.number,
    lastExchangeDate: PropTypes.number,
    lastGrantDate: PropTypes.number,
    pendingContribution: PropTypes.bool,
    pendingExchange: PropTypes.bool,
    pendingGrant: PropTypes.bool,
    role: PropTypes.string,
    saFirstName: PropTypes.string,
    saLastName: PropTypes.string,
    saMiddleName: PropTypes.string,
    saPrefix: PropTypes.string,
    saSuffix: PropTypes.string,
    state: PropTypes.string,
    ytd: PropTypes.shape({
      contributionYtd: PropTypes.number,
      grantsYtd: PropTypes.number,
      investmentYtd: PropTypes.number,
    }),
  }),
  isLoading: PropTypes.bool,
  resetEnableBack: PropTypes.func,
  roles: PropTypes.arrayOf(PropTypes.string),
  setRedirectEnableBack: PropTypes.func,
  states: PropTypes.arrayOf(PropTypes.string),
  userData: PropTypes.shape({
    company: PropTypes.string,
    faFirstName: PropTypes.string,
    faLastName: PropTypes.string,
    faMiddleName: PropTypes.string,
    faPrefix: PropTypes.string,
    faSuffix: PropTypes.string,
    noOfManAccts: PropTypes.number,
    saFirstName: PropTypes.string,
    saLastName: PropTypes.string,
    saMiddleName: PropTypes.string,
    saPrefix: PropTypes.string,
    saSuffix: PropTypes.string,
    totalAssets: PropTypes.number,
  }),
};
